import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv1310SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1310SearchParams = z.infer<typeof Inv1310SearchParamsSchema>

export const Inv1310SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  date: z.coerce.date(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isFulfilled: z.boolean().nullable(),
  confirmed: z.boolean().nullable(),
})

export type Inv1310SearchResultModel = z.infer<
  typeof Inv1310SearchResultModelSchema
>

export const Inv1310SearchResultSchema = z
  .object({
    data: z.array(Inv1310SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1310SearchResult = z.infer<typeof Inv1310SearchResultSchema>

// Search Params Schema
export const ItemRejectedLookupSearchParamsSchema = z.object({
  partyId: z.string({ required_error: 'กรุณาระบุผู้จำหน่าย' }).refine(
    (v) => {
      return !Number.isNaN(v) && Number(v) > 0
    },
    { message: 'กรุณาระบุผู้จำหน่าย' }
  ),
  lotNo: z.string().optional(),
  itemId: z.coerce.number().optional(),
})

export type ItemRejectedLookupSearchParams = z.infer<
  typeof ItemRejectedLookupSearchParamsSchema
>

// Search Result Model Schema
export const ItemRejectedLookupSearchResultModelSchema = z.object({
  id: z.number().default(0),
  itemId: z.number(),
  isClaimItem: z.boolean(),
  lotDate: z.coerce.date(),
  location: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  qty: z.number(),
  unit: z.string().default('pcs'),
})

export type ItemRejectedLookupSearchResultModel = z.infer<
  typeof ItemRejectedLookupSearchResultModelSchema
>

// Search Result Schema
export const ItemRejectedLookupSearchResultSchema = z
  .array(ItemRejectedLookupSearchResultModelSchema)
  .default([])

export type ItemRejectedLookupSearchResult = z.infer<
  typeof ItemRejectedLookupSearchResultSchema
>
